import {
  buildDrivingRouteGroupName,
  buildModePointDraft,
  normalizeDrivingRouteGroupKey,
} from "@utils/mode_tool/modeRoute";

export function normalizeRouteKey(mode, routeKey) {
  if (String(mode || "") !== "walking") return "default";
  return String(routeKey || "");
}

export function getModePoints(state, startPointId, mode, routeKey = "default") {
  const normalizedRouteKey = normalizeRouteKey(mode, routeKey);
  return (
    state.modePointsByStartPoint?.[startPointId]?.[mode]?.[normalizedRouteKey] ||
    []
  );
}

export function buildContextKey(context = {}) {
  const ownerId = String(context?.ownerId || "");
  const routeTypeId = String(context?.routeTypeId || "");
  const mode = String(context?.mode || "");
  if (!ownerId || !routeTypeId || !mode) return "";
  return `${ownerId}::${routeTypeId}::${mode}`;
}

export function isRootDrivingRoutePoint(point = {}) {
  return (
    normalizeDrivingRouteGroupKey(
      point?.routeGroup ?? point?.route_group ?? "",
      point?.routeGroupName ?? point?.route_group_name ?? "",
      Number(point?.order ?? point?.number_point ?? 0) || 0,
    ) === "main"
  );
}

export function normalizeDrivingPointsSequentially(pointsList = []) {
  return (Array.isArray(pointsList) ? pointsList : []).map((point, index) => {
    const nextOrder = index + 1;
    const routeGroup = normalizeDrivingRouteGroupKey(
      point?.routeGroup ?? point?.route_group ?? "",
      point?.routeGroupName ?? point?.route_group_name ?? "",
      nextOrder,
    );
    const preservedAlternateGroupName =
      routeGroup !== "main"
        ? String(point?.routeGroupName ?? point?.route_group_name ?? "").trim()
        : "";
    return buildModePointDraft({
      ...(point || {}),
      order: nextOrder,
      routeGroup,
      routeGroupName:
        preservedAlternateGroupName ||
        buildDrivingRouteGroupName(nextOrder, routeGroup),
      labelCode:
        routeGroup !== "main"
          ? String(
              point?.labelCode ??
                point?.label_code ??
                preservedAlternateGroupName,
            )
          : "",
      routeGroupParentPointId: "",
    });
  });
}

export function normalizeDrivingMainWithoutTouchingAlternates(pointsList = []) {
  let mainOrder = 0;
  return (Array.isArray(pointsList) ? pointsList : []).map((point) => {
    const {
      __preserveExistingMainOrder: preserveExistingMainOrder,
      ...cleanPoint
    } = point || {};
    const routeGroup = normalizeDrivingRouteGroupKey(
      cleanPoint?.routeGroup ?? cleanPoint?.route_group ?? "",
      cleanPoint?.routeGroupName ?? cleanPoint?.route_group_name ?? "",
      Number(cleanPoint?.order ?? cleanPoint?.number_point ?? 0) || 0,
    );
    if (routeGroup !== "main") return cleanPoint;
    const existingOrder = Number(cleanPoint?.order ?? 0) || 0;
    const nextOrder =
      preserveExistingMainOrder && existingOrder > mainOrder
        ? existingOrder
        : mainOrder + 1;
    mainOrder = nextOrder;
    return buildModePointDraft({
      ...cleanPoint,
      order: nextOrder,
      routeGroup: "main",
      routeGroupName: buildDrivingRouteGroupName(nextOrder, "main"),
      routeGroupParentPointId: "",
    });
  });
}
